import type { ReactNode } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function PageIntro({
  title,
  description,
  eyebrow,
  children,
}: {
  title: string;
  description: string;
  eyebrow?: string;
  children?: ReactNode;
}) {
  return (
    <Card className="overflow-hidden rounded-[2rem] border border-lp-border bg-white/95 shadow-[0_18px_60px_rgba(62,50,43,0.08)]">
      <CardHeader className="relative p-7 sm:p-8">
        <div className="pointer-events-none absolute right-0 top-0 h-32 w-32 rounded-bl-[4rem] bg-lp-highlight/45" />
        {eyebrow ? <p className="text-xs font-semibold uppercase tracking-[0.24em] text-lp-primary">{eyebrow}</p> : null}
        <CardTitle className="relative max-w-4xl font-headline text-3xl leading-tight text-lp-text sm:text-4xl">{title}</CardTitle>
        <CardDescription className="relative max-w-3xl text-sm leading-6 text-lp-text-muted sm:text-base">{description}</CardDescription>
      </CardHeader>
      {children ? <CardContent className="px-7 pb-7 sm:px-8 sm:pb-8">{children}</CardContent> : null}
    </Card>
  );
}
